module.exports = __webpack_public_path__ + "img/材料力学6_4_3.a3d459b8.jpg";